import type { DocumentStatus } from '@chukua/common';

/** Shared shapes for a truck's, trailer's or driver's compliance documents (gitaumoses4/chukua#17) — the same API response shape across all three holders. */

export interface ComplianceDocumentEntry {
  id: string;
  number: string;
  issuer: string;
  issueDate: string;
  expiryDate: string;
  contentType: string;
  createdAt: string;
}

/** One row per active document type applicable to the holder — `current` is null and `status` is `missing` when nothing has been attached yet. */
export interface ComplianceDocumentView {
  documentTypeId: string;
  documentTypeCode: string;
  documentTypeName: string;
  status: DocumentStatus;
  current: ComplianceDocumentEntry | null;
  history: ComplianceDocumentEntry[];
}

export interface PresignedUpload {
  key: string;
  url: string;
  fields: Record<string, string>;
  expiresAt: string;
}

/** The client posts the file straight to the presigned URL — it never passes through the API (CLAUDE.md → storage rule). */
export async function uploadToPresignedUrl(upload: PresignedUpload, file: File): Promise<void> {
  const form = new FormData();
  Object.entries(upload.fields).forEach(([key, value]) => form.append(key, value));
  form.append('file', file);

  const res = await fetch(upload.url, { method: 'POST', body: form });
  if (!res.ok) throw new Error(`Upload failed with status ${res.status}`);
}
